<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent hide-overlay value="1" class="social-media">
      <v-card class="share-dialog">
        <div :class="[lang === 'ar' ? 'flex-row-reverse' : '', 'd-flex align-items-center justify-content-between space']">
          <v-card-title class="dialog-title">
            {{$store.state.sharedTitle}}
          </v-card-title>
          <div class="close-dialog-btn">
            <img @click="closeDialog" src="../../assets/icons/closeBtn.svg"/>
          </div>
        </div>
        <div class="dialog-content space"> {{$t('shareDialog.shareVia')}} </div>
        <div class="d-flex justify-content-between sharing-container">
          <template>
          </template>
          <div v-if="deviceType">
            <FacebookMessenger :url="link" :description="text" btnText="" :hasIcon="hasIcon"/>
          </div>
          <div>
            <WhatsAppShareButton :url="link" :description="text" btnText="" :hasIcon="hasIcon"/>
          </div>
          <div>
            <TelegramButton :url="link" :description="text" btnText="" :hasIcon="hasIcon"/>
          </div>
          <div>
            <FacebookButton :url="link" :description="text" btnText="" :hasIcon="hasIcon"/>
          </div>
          <div>
            <TwitterButton :url="link" :description="text" btnText="" :hasIcon="hasIcon"/>
          </div>
        </div>
        <div class="dialog-content space"> {{$store.state.urlTitle}} </div>
        <div id="copy-container" :class="[lang === 'ar' ? 'flex-row-reverse'  : '' ,'d-flex copy-link justify-content-between space px-sm-4']">
          <div :class="[lang === 'ar' ? 'right-align right-dir' : 'left-align', 'input-field-container']">
            <input id="copy-field" v-model="$store.state.sharingLink" class="copy-link-field" type="text" :class="lang === 'en' ? 'pr-sm-2'  : 'pl-sm-2'" readonly />
          </div>
          <div class="link-button-container">
            <button @click="copyLink" id="copy-btn" class="copy-link-btn">
              <span class="copy-btn-text">{{$t('shareDialog.copy')}}</span>
            </button>
          </div>
        </div>
        <div></div>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import $ from 'jquery'
import WhatsAppShareButton from 'vue-share-buttons/src/components/WhatsAppButton'
import TwitterButton from 'vue-share-buttons/src/components/TwitterButton'
import FacebookButton from 'vue-share-buttons/src/components/FacebookButton'
import TelegramButton from 'vue-share-buttons/src/components/TelegramButton'
import FacebookMessenger from 'vue-share-buttons/src/components/FacebookMessengerButton'
export default {
  components: { WhatsAppShareButton, TwitterButton, FacebookButton, TelegramButton, FacebookMessenger },
  data () {
    return {
      dialog: true,
      link: `${this.$store.state.sharedMessage} \n${this.$store.state.sharingLink}`,
      lang: this.$lang,
      hasIcon: false,
      insideBtn: 'copy',
      deviceType: true,
      text: 'welcome to imtn website'
    }
  },
  mounted () {
    this.$lang === 'ar' ? $('.dialog-content').css('text-align', 'right') : $('.dialog-content').css('text-align', 'left')
    this.$lang === 'ar' ? this.insideBtn = 'نسخ' : this.insideBtn = 'copy'
    this.detect()
    $('.v-dialog__content.v-dialog__content--active').css('backdrop-filter', 'blur(10px)')
    $('.v-dialog__content.v-dialog__content--active').css('z-index', '100000')
    setTimeout(() => {
      this.$lang === 'ar' ? $('.copy-btn').css('font-family', 'Mtn-arabic-bold') : $('.copy-btn-text').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.dialog-title').css('font-family', 'Mtn-arabic-regular') : $('.dialog-title').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.dialog-content').css('font-family', 'Mtn-arabic-regular') : $('.dialog-content').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.dialog-title').css('font-family', 'Mtn-arabic-bold') : $('.dialog-title').css('font-family', 'Mtn-bold')
    })
  },
  methods: {
    detect () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.deviceType = true
      } else {
        this.deviceType = false
      }
    },
    copyLink () {
      document.getElementById('copy-field').select()
      document.execCommand('copy', this.link)
      this.insideBtn = this.lang === 'en' ? 'copied!' : 'تم النسخ'
    },
    closeDialog () {
      this.$emit('close-dialog')
      this.$store.state.sharingLink = ''
    }
  }
}
</script>
<style>
button.share-button.share-button--twitter,
button.share-button.share-button--whatsApp,
button.share-button.share-button--facebook,
button.share-button.share-button--telegram,
button.share-button.share-button--facebookMessenger,
button img
{
  background-color: transparent;
  background-size: cover;
  width: 70px;
  height: 70px;
  border-radius: 30%;
  padding: 0;
  margin: 0;
}
button.share-button.share-button--facebookMessenger{
  background-image: url("../../assets/icons/massenger.svg");
}
button.share-button.share-button--telegram{
  background-image: url("../../assets/icons/telegram.svg");
}
button.share-button.share-button--whatsApp{
  background-image: url("../../assets/icons/whatsapp.svg");
}
button.share-button.share-button--twitter{
  background-image: url("../../assets/icons/twitter.svg");
}
button.share-button.share-button--facebook{
  background-image: url("../../assets/icons/facebook-dialog.svg");
}
.share-dialog.v-card.v-sheet.theme--light{
  width: 600px;
}
.v-dialog.v-dialog--active.v-dialog--persistent,
.share-dialog.v-card.v-sheet.theme--light{
  border-radius: 30px;
  box-shadow: unset;
}
.share-dialog.v-card.v-sheet.theme--light {
  background: rgba(255,255,255,.8);
  opacity: 0.9;
  padding: 10px 50px;
  font-family: Mtn-regular;
}
.v-card__title.dialog-title{
  font-family: Mtn-bold;
  padding: 20px 0;
}
.dialog-content{
  padding: 0 0 10px 0;
  font-family: Mtn-bold;
}
.close-dialog-btn{
  width: 40px;
}
.close-dialog-btn img,
.icon-container img{
  width: 100%;
  cursor: pointer;
}
.icon-container{
  width: 70px;
}
.copy-link{
  border: 2px solid #000;
  width: 100%;
  border-radius: 8px;
  height: 60px;
}
.input-field-container{
  width: 75%;
  overflow-x: auto;
}
#copy-field{
  width: 100%;
}
.copy-link-field:focus {
  outline: 0
}
button.copy-link-btn{
  width: 110px;
  height: 75%;
  align-self: center;
  border-radius: 8px;
  background: #FFCB05;
  font-family: Mtn-bold;
  padding: 8px ;
}

#copy-container,
.sharing-container{
  margin-bottom: 60px;
}
#copy-container{
  align-items: center;
}
.share-dialog.v-card.v-sheet.theme--light{
  margin: 0 auto !important;
}
@media (max-width: 1264px) and (min-width: 920px) {
  .share-dialog.v-card.v-sheet.theme--light{
    width: 600px !important;
  }
}
@media (max-width: 920px) {
  .share-dialog.v-card.v-sheet.theme--light{
    width: 700px;
  }
}
@media (max-width: 790px) {
  .share-dialog.v-card.v-sheet.theme--light{
    width: 600px;
  }
}
@media (max-width: 700px) {
  .share-dialog.v-card.v-sheet.theme--light{
    width: 600px;
  }
  button.share-button.share-button--twitter,
  button.share-button.share-button--whatsApp,
  button.share-button.share-button--facebook,
  button.share-button.share-button--telegram,
  button.share-button.share-button--facebookMessenger,
  button img
  {
    width: 60px;
    height: 60px;
  }
  button.copy-link-btn{
    width: 90px;
  }
}
@media (max-width: 616px) {
  .share-dialog.v-card.v-sheet.theme--light{
    width: 500px;
  }
  #copy-container{
    display: block !important;
    border: none;
    padding: 0 !important;
  }
  .sharing-container{
    margin-bottom: 25px;
  }
  .input-field-container{
    border: 2px solid #000;
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;
  }
  #copy-field{
    width: 100%;
    line-height: 1.3;
    padding: 18px 18px;
  }
  .link-button-container{
    margin-top: 10px;
  }
  #copy-btn{
    width: 100%;
    padding: 10px 0;
  }
  button.share-button.share-button--twitter,
  button.share-button.share-button--whatsApp,
  button.share-button.share-button--facebook,
  button.share-button.share-button--telegram,
  button.share-button.share-button--facebookMessenger,
  button img
  {
    width: 50px;
    height: 50px;
  }
  .share-dialog.v-card.v-sheet.theme--light{
    padding: 10px 20px;
  }
}
@media screen and (max-width: 500px) {
  .share-dialog.v-card.v-sheet.theme--light{
    width: 400px;
  }
}
@media (max-width: 450px) {
  .share-dialog.v-card.v-sheet.theme--light{
    width: 300px;
  }
  button.share-button.share-button--twitter,
  button.share-button.share-button--whatsApp,
  button.share-button.share-button--facebook,
  button.share-button.share-button--telegram,
  button.share-button.share-button--facebookMessenger,
  button img
  {
    width: 40px;
    height: 40px;
  }
  .v-dialog.v-dialog--active.v-dialog--persistent{
    width: 95%;
  }
  .close-dialog-btn{
    width: 30px;
  }
}
</style>
